import { TabContent, TabPane } from "reactstrap";
import TabHeaders from "./TabHeaders";
import { TabCustomizerType } from "../../../Type/CustomizerType";
import SidebarCusmizer from "../SidebarCusmizer";

const TabCustomizer = ({ callbackNav, selected }: TabCustomizerType) => {
  return (
    <TabContent activeTab={selected}>
      <TabHeaders callbackNav={callbackNav} />
      <div className="customizer-body custom-scrollbar tab-content">
        <TabPane tabId="sidebar-type"><SidebarCusmizer /></TabPane>
      </div>
    </TabContent>
  );
};

export default TabCustomizer;
